import React, { useEffect } from "react";
import { Box, Grid, TextField, InputLabel, MenuItem } from "@material-ui/core";
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { BootstrapInput } from "containers/labs/style";
import { getSelectedIdFromArray } from "utils/common";
import DateAndTimePicker from "components/dateTimePicker";
import { timers } from "constants/admin/masters/labs";
import uuid from 'react-uuid';
import { useForm } from "hooks/useForm";
import { useStyles } from "./style";
import moment from 'moment';

export default function PermissionSettingsConfig(props) {
    const classes = useStyles();
    const { permissionConfig, bindGeneralInfo } = props;
    const { max_time, max_extension, extension_time, allowed_from, allowed_to } = permissionConfig;
    const initialFormData = { // used to initialize the data
        max_time: max_time,
        max_extension: max_extension || 1,
        extension_time: extension_time || 30,
        allowed_from: allowed_from || null,
        allowed_to: allowed_to || null,
    };

    const { data, populateForm, handleChange, handleChangeCustom } = useForm({
        initialValues: initialFormData,
    });

    useEffect(() => {
        populateForm(initialFormData);
        // eslint-disable-next-line
    }, [permissionConfig]);

    const handleFromDate = (date) => {
        bindGeneralInfo('from_date', date ? moment(date).format('YYYY-MM-DD HH:mm') : null)
    }

    const handleToDate = (date) => {
        bindGeneralInfo('to_date', date ? moment(date).format('YYYY-MM-DD HH:mm') : null)
    }

    return (
        <>
            <Box display='flex' overflow='hidden' paddingBottom='16px'>
                <Grid item xs={12}>
                    <Box className={classes.header} >Settings</Box>
                    <TextField fullWidth
                        name="duration"
                        label="Duration (mins)"
                        variant="outlined"
                        type='number'
                        value={data.max_time}
                        onChange={handleChange('max_time')}
                        onBlur={() => bindGeneralInfo('max_time', data.max_time)}
                        classes={{ root: classes.textField }}
                        InputProps={{
                            classes: {
                                input: classes.inputField,
                                root: classes.base,
                                focused: classes.focused,
                                notchedOutline: classes.notchedOutline
                            },
                        }}
                        InputLabelProps={{
                            shrink: true,
                            style: { color: '#2a2c2e' },
                        }}
                    />
                    <TextField fullWidth
                        name="extensions"
                        label="Amount of extensions"
                        variant="outlined"
                        type='number'
                        value={data.max_extension}
                        onChange={handleChange('max_extension')}
                        onBlur={() => bindGeneralInfo('max_extension', data.max_extension)}
                        classes={{ root: classes.textField }}
                        InputProps={{
                            classes: {
                                input: classes.inputField,
                                root: classes.base,
                                focused: classes.focused,
                                notchedOutline: classes.notchedOutline
                            },
                        }}
                        InputLabelProps={{
                            shrink: true,
                            style: { color: '#2a2c2e' },
                        }}
                    />

                    <Box display='flex' flexDirection='column' >
                        <FormControl className={classes.formControl}>
                            <InputLabel className={classes.selectLabel}>Extension time (mins)</InputLabel>
                            <Select
                                labelId="demo-customized-select-label"
                                value={getSelectedIdFromArray(timers, data.extension_time) || 0}
                                onChange={(event) => {
                                    handleChangeCustom('extension_time', getSelectedIdFromArray(timers, event.target.value))
                                }}
                                onBlur={() => bindGeneralInfo('extension_time', data.extension_time)}
                                input={<BootstrapInput />}
                            >
                                {timers.map(option => {
                                    return (
                                        <MenuItem key={uuid()} className={classes.menuItem} value={option.value}>{option.label}</MenuItem>
                                    );
                                })}
                            </Select>
                        </FormControl>

                    </Box>
                    <Box className='permission-calendar'>
                        <DateAndTimePicker
                            label='Allowed time from'
                            date={data.allowed_from}
                            handleDateChange={handleFromDate}

                        />
                    </Box>

                    <Box className='permission-calendar'>
                        <DateAndTimePicker
                            label='Allowed time to'
                            date={data.allowed_to}
                            handleDateChange={handleToDate}
                        />
                    </Box>
                </Grid>
            </Box>
        </>
    )
}